import api from "../helpers/util";

export const fetchSkinsByDate = async (species, date) => {
  try {
    const response = await api.get(
      "/scheduling/skins/" + species + "/date/" + date
    );
    return response?.data?.result ?? "No  skins found.";
  } catch (error) {
    console.log("fetching Beef Skins err", error);
    throw new Error("Error fetching skins :", error);
  }
};

export const createSkin = async (species, skinData) => {
  try {
    const response = await api.post(
      "/scheduling/skins/" + species + "/createSkin",
      skinData
    );
    // const data = await response.json();
    console.log("created skin", response.data);
    return response.data;
  } catch (error) {
    throw new Error("Error creating skin:", error);
  }
};
